module.exports = __webpack_public_path__ + "img/reign-of-serenity-2.f6c6a6f5.webp";